import styled from 'styled-components'
import { TableCell, TableRow } from '@material-ui/core'
import { colors, theme, StyledH5 } from '../../../../../theme/Global'

export const CustomTableHeadRow = styled(TableRow)`
  && {
    height: 45px;
    > tr {
      ${(props) => (props.sticky ? 'position: -webkit-sticky; position: sticky;' : null)}
    }
  }
`
export const CustomTableHeadLoadingRow = styled(TableRow)`
  && {
    height: 45px;
    background-color: ${colors.lightGrey};
  }
`

export const CustomTableHeadCell = styled(TableCell)`
  && {
    margin: 0;
    padding: 0 25px 0 25px;
    border-bottom: none;
    width: ${(props) => props.headerwidth};
    background-color: ${colors.darkGrey};
    text-align: left;
    top: 0;
    left: 0;
    z-index: 2;
    ${(props) => (props.sticky ? 'position: -webkit-sticky; position: sticky;' : null)}
    &.sticky {
      z-index: 3 !important;
    }
  }
`

export const CustomH5 = styled(StyledH5)`
  && {
    color: ${theme.colors.whiteText};
    cursor: default;
    font-size: 14px;
    margin: 0;
    padding: 0;
    text-align: left;
    display: inline-flex;
    position: relative;
    top: 0px;
    width: 100%;
  }
`
